import {useState} from "react";
import Body from "../../../../../../../material/skeleton/Body";
import Box from "@mui/material/Box";
import {Button, TextField} from "@mui/material";
import Footer from "../../../../../../../material/skeleton/Footer";
import parameter from "../../../../../../../enum/parameter";
import {Add, CheckCircle} from "@mui/icons-material";
import NotifyDescribeActionTaken from "./NotifyDescribeActionTaken";

const ARRAY = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];

export default function ({next}) {
    const [actionResult, setActionResult] = useState({1: ""});

    const nextStep = () => {
        next(actionResult);
    }

    const addStep = () => {
        const res = {...actionResult};

        res[Object.keys(actionResult).length + 1] = "";

        setActionResult(res);
    }

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyDescribeActionTaken/>
                </Box>

                {
                    Object.keys(actionResult).map((key) => {
                        return (
                            <Box key={key} mt={2} px={2}>
                                <TextField
                                    label={`Action ${key}`}
                                    fullWidth={true}
                                    multiline={true}
                                    minRows={2}
                                    onChange={e => {
                                        const res = {...actionResult};

                                        res[key] = e.target.value;

                                        setActionResult(res);
                                    }}
                                    data-test={`input-step-${key}`}
                                />
                            </Box>
                        )
                    })
                }

                <Box mt={2} px={2}>
                    <Button
                        startIcon={<Add/>}
                        variant="contained"
                        fullWidth
                        color={"info"}
                        onClick={addStep}
                        data-test="button-add-additional-step"
                    >
                        Ajouter une action
                    </Button>
                </Box>
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    data-test="button-next-step"
                >
                    Étape suivante
                </Button>
            </Footer>
        </>
    );
}